(function () {
  var ease = function (fn) { return window.requestAnimationFrame ? requestAnimationFrame(fn) : setTimeout(fn, 16); };

  /* Some themes (Shopify's Horizon among them) set html/body to overflow:hidden
     and scroll an inner wrapper instead, so window never fires "scroll" and
     window.scrollY stays 0. Find whatever actually scrolls and listen there. */
  function findScroller() {
    var de = document.documentElement;
    var deHidden = getComputedStyle(de).overflowY === "hidden";
    var bodyHidden = getComputedStyle(document.body).overflowY === "hidden";
    if (!deHidden && !bodyHidden && de.scrollHeight > de.clientHeight + 1) return null;
    var cands = document.querySelectorAll(".page-wrapper, #MainContent, main, body > div");
    for (var i = 0; i < cands.length; i++) {
      var n = cands[i], oy = getComputedStyle(n).overflowY;
      if ((oy === "auto" || oy === "scroll") && n.scrollHeight > n.clientHeight + 1) return n;
    }
    return null;
  }
  var scroller = findScroller();
  function onScroll(fn) { (scroller || window).addEventListener("scroll", fn, { passive: true }); }

  /* on-load hero reveal */
  ease(function () { setTimeout(function () { document.documentElement.classList.add("is-ready"); }, 150); });

  /* scroll reveals */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
  }, { rootMargin: "-10% 0px" });
  document.querySelectorAll(".tv-reveal").forEach(function (el) { io.observe(el); });

  /* announcement rotation */
  document.querySelectorAll("[data-tv-announcement]").forEach(function (bar) {
    var msgs = bar.querySelectorAll(".tv-announcement__msg");
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      var cur = msgs[i]; i = (i + 1) % msgs.length;
      cur.classList.remove("is-active"); cur.classList.add("is-leaving");
      setTimeout(function () { cur.classList.remove("is-leaving"); }, 700);
      msgs[i].classList.add("is-active");
    }, 4500);
  });

  /* hero tilt + parallax */
  var hero = document.querySelector("[data-tv-hero]");
  if (hero) {
    var frame = hero.querySelector(".tv-hero__frame");
    var img = hero.querySelector("[data-tv-parallax]");
    hero.addEventListener("mousemove", function (e) {
      var r = hero.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      frame.style.transform = "rotateX(" + (-y * 12) + "deg) rotateY(" + (x * 16) + "deg)";
    });
    hero.addEventListener("mouseleave", function () { frame.style.transform = ""; });
    var onHeroScroll = function () {
      /* viewport-relative, so it works whether the window or a wrapper scrolls */
      var past = -hero.getBoundingClientRect().top;
      var p = Math.min(1, Math.max(0, past / hero.offsetHeight));
      if (img) img.style.transform = "scale(1.18) translateY(" + p * 18 + "%)";
    };
    onScroll(onHeroScroll); onHeroScroll();
  }

  /* craft columns gentle float — every column gets the SAME offset, so the
     three photos drift together and always stay aligned with each other. */
  var craft = document.querySelector("[data-tv-craft]");
  if (craft) {
    var cols = craft.querySelectorAll("[data-tv-float]");
    var tick = function () {
      if (window.innerWidth < 768) {          /* no drift on phones */
        cols.forEach(function (c) { c.style.transform = ""; });
        return;
      }
      var r = craft.getBoundingClientRect();
      var p = (window.innerHeight - r.top) / (window.innerHeight + r.height) - 0.5;
      p = Math.min(0.5, Math.max(-0.5, p)); /* keep the drift inside its intended range */
      var y = -p * 120;
      cols.forEach(function (c) { c.style.transform = "translateY(" + y + "px)"; });
    };
    onScroll(tick);
    window.addEventListener("resize", tick, { passive: true });
    tick();
  }

  /* rotating hero badge — fit the wording to the ring.
     The circle is fixed (r=36, so ~226 user units round) but the wording is a
     theme setting, and anything longer than the default ran off the end of the
     path and was clipped mid-word. Solving for the letter-spacing makes the
     text close the ring exactly, whatever is typed, so the trailing "·" always
     meets the first word. Measured after the webfont loads, because Montserrat
     and the fallback have different metrics. */
  var fitBadges = function () {
    document.querySelectorAll(".tv-hero__badge").forEach(function (badge) {
      var path = badge.querySelector("path");
      var text = badge.querySelector("text");
      if (!path || !text || !text.getComputedTextLength) return;
      var chars = (text.textContent || "").length;
      if (!chars) return;
      var ring = path.getTotalLength();
      text.style.fontSize = "";
      text.style.letterSpacing = "0px";
      var glyphs = text.getComputedTextLength();      /* glyph widths, no tracking */
      if (!glyphs) return;
      if (glyphs > ring) {
        /* more text than the ring can hold at any tracking — shrink the type
           rather than let the letters overlap each other. */
        text.style.fontSize = (parseFloat(getComputedStyle(text).fontSize) * (ring / glyphs)) + "px";
        glyphs = text.getComputedTextLength();
      }
      /* letter-spacing adds a gap after every character, the last one included,
         which is precisely the gap that closes the loop. */
      text.style.letterSpacing = ((ring - glyphs) / chars) + "px";
    });
  };
  fitBadges();
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(fitBadges); }
})();
